export default defineNuxtRouteMiddleware(async to => {
	const {getUrlSegments} = useUrl();
	const path = getUrlSegments(to.path);
	if(to.path.startsWith('/instashop') && path.length > 1) {
		return navigateTo('/instashop/', {redirectCode: 301});
	}
});